import type { Cart } from "@packages/sdk";

import { HallowCartGrant } from "../types/enums/hallowCartGrant.types";
import { getCartGrant } from "./getCartGrant";

type GetTrialDiscountPercentProps = { cart?: Cart };

export const getTrialDiscountPercent = ({
  cart,
}: GetTrialDiscountPercentProps) => {
  if (cart)
    return parseInt(
      getCartGrant({
        cart,
        filter: (item) => item.type === "percent",
        grant: HallowCartGrant.DiscountGrant,
      })?.variables?.amount ?? 0,
    );

  return 0;
};
